import ReactGA from 'react-ga'

const TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID

export function setUtm() {
  const urlParams = new URLSearchParams(window.location.search)
  console.log(urlParams)
  const utmSource = urlParams.get('utm_source')
  if (utmSource) {
    window.sessionStorage.setItem('utmSource', utmSource)
  }
}

export function getUtm() {
  return window.sessionStorage.getItem('utmSource')
}

export const setup = () => {
  ReactGA.initialize(TRACKING_ID)
  ReactGA.plugin.require('ecommerce', { debug: true })
  setUtm()
}

// export const trackReferral = async ({
//   label, // labels array
//   transactionId, //hash
//   type, // register
//   price, // in usd
//   domainName
// }) => {
//   const referrer = getUtm()
//   function track() {
//     ReactGA.event({
//       category: 'referral',
//       action: `${type} domain`,
//       labels,
//       transactionId,
//       type,
//       referrer
//     })
//     ReactGA.plugin.execute('ecommerce', 'addTransaction', {
//       id: transactionId, // Transaction ID. Required.
//       affiliation: referrer, // Affiliation or store name.
//       revenue: price // Grand Total.
//     })

//     ReactGA.plugin.execute('ecommerce', 'addItem', {
//       id: transactionId,
//       name: domainName,
//       sku: domainName,
//       category: type
//     })

//     ReactGA.plugin.execute('ecommerce', 'send')
//     ReactGA.plugin.execute('ecommerce', 'clear')
//   }

//   track()
// }

export const trackEvent = (category, action, label) => {
  ReactGA.event({
    category,
    action,
    label
  })
}

export const trackDomainRegister = async ({
  label, // label
  transactionId, //hash
  type, // register
  price // in usd
}) => {
  const referrer = getUtm()
  function track() {
    ReactGA.event({
      category: 'Domain registration',
      action: `${type} domain`,
      label,
      transactionId,
      type,
      referrer
    })
    ReactGA.plugin.execute('ecommerce', 'addTransaction', {
      id: transactionId, // Transaction ID. Required.
      affiliation: 'Web3domains', // Affiliation or store name.
      revenue: price // Grand Total.
    })

    ReactGA.plugin.execute('ecommerce', 'addItem', {
      id: transactionId,
      name: label,
      sku: label,
      category: type
    })

    ReactGA.plugin.execute('ecommerce', 'send')
    ReactGA.plugin.execute('ecommerce', 'clear')
  }

  track()
}
